var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.169922,
    y: 0.886719,
    width: 23.4082,
    height: 23.4082,
    rx: 11.7041,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3668 9.09473H8.57347C7.91024 9.09473 7.37305 9.66433 7.37305 10.366V16.721C7.37305 17.4233 7.91024 17.9923 8.57347 17.9923H15.1758C15.839 17.9923 16.3762 17.4233 16.3762 16.721V12.0694L14.027 14.5566C13.8218 14.776 13.5547 14.9276 13.2611 14.9912L11.652 15.3321C10.6016 15.5542 9.67606 14.5741 9.88613 13.4625L10.2078 11.7585C10.2661 11.4512 10.4089 11.1685 10.6184 10.947L12.3668 9.09473Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4843 7.97996C17.4236 7.82632 17.3346 7.68543 17.222 7.56461C17.1112 7.44645 16.9777 7.35192 16.8295 7.28671C16.6834 7.22257 16.5256 7.18945 16.3661 7.18945C16.2066 7.18945 16.0488 7.22257 15.9027 7.28671C15.7545 7.35192 15.621 7.44645 15.5102 7.56461L15.1825 7.91153L16.8943 9.72417L17.222 9.37665C17.3358 9.25674 17.4249 9.11561 17.4843 8.9613C17.6079 8.64587 17.6079 8.29539 17.4843 7.97996ZM16.0462 10.6227L14.3338 8.80945L11.4666 11.8465C11.4243 11.8916 11.3957 11.9478 11.3843 12.0086L11.0626 13.7132C11.0206 13.9352 11.2061 14.1309 11.4156 14.0865L13.0253 13.7462C13.0839 13.7331 13.1372 13.7028 13.1784 13.6592L16.0462 10.6227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.46ad0d80ab948f80e4e5295436b944d3.svg";
export { ForwardRef as ReactComponent };